var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{staticClass:"base-head",attrs:{"title":_vm.title,"border":false,"left-arrow":"","placeholder":"","z-index":"9","fixed":""},on:{"click-left":_vm.goBack},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('van-icon',{staticClass:"base-head__goback",attrs:{"name":"arrow-left"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }